<template>
  <button
    class="mt-12 bg-cyan-600 text-coolGray-50 text-lg py-2 px-6 lg:text-xl lg:py-4 lg:px-12 font-semibold rounded-md shadow-md hover:bg-cyan-700 transition duration-150 ease-in-out flex items-center focus:outline-none focus:ring focus:ring-cyan-700"
  >
    <slot></slot>
  </button>
</template>
